import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_goldenbull.png",
      alt: "Estratégias Golden Bull",
    },
    title: "Conheça o Smart Bull um Algoritmo Quântico",

    // String ou array de strings
    text: [
      "Não importa se você é um iniciante ou um expert no mundo dos investimentos. O Smart Bull surgiu para atender a todos os níveis de experiência. Desenvolvemos um algoritmo que atua por você através de uma Estratégia Quântica, gerando operações financeiras na sua conta de forma 100% Automática.",
      "Seu principal ativo é o seu tempo, acabe com suas preocupações operacionais e concentre-se no que realmente importa, venha para Golden!",
    ],
    testimonial: {
      text: "Não posso deixar de falar da eficiência de uma ferramenta,que nós deixa muito confortável em dizer o quanto estou seguro e contente com vocês, tudo muito profissional, só tenho a agradecer essa parceria de muito sucesso!!!! Parabéns equipe Golden!!!👏🏻👏🏻👏🏻",
      author: {
        name: "Eduardo Celeghini",
        // picture: "",
      },
    },
  },

  strategies: {
    title: "Estratégia Smart Bull",
    heading: "Algoritmo que analisa dados quantitativos",
    subtitle:
      "Para tomada de decisões na compra ou venda do Mini Dólar futuro. Seja um investidor e comece agora mesmo com alguns cliques.",
  },

  cta: {
    title: "Está pronto para começar?",
    subtitle: "Ative agora mesmo a automação Smart Bull.",
    buttonText: "Quero investir",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "Golden Bull",
    col1: [
      "A história da Golden Bull iniciou em meados de 2020 através de uma curiosidade sobre o que era o mercado e quais eram seus caminhos para começar a investir.",
      "Depois de sofrer com a falta de informação real e objetiva sobre o que é e como funciona o mercado, resolvemos desenvolver uma automação testada e validada, para realmente ajudar e mostrar o melhor caminho para quem quer iniciar nesta jornada.",
    ],
    col2: [
      "Formado por um time de profissionais com mais de 5 anos de experiência no mercado financeiro, como Victor Hugo Montoro, trader experiente em mercado futuro, e Leonardo Martins, especialista em automatização de processos.",
      "Desde então estamos buscando por mais conhecimento e novos desenvolvimentos, para aprimorar e facilitar o processo de quem quer se tornar um investidor de sucesso.",
    ],
  },

  stats: {
    title: "Alguns números do Smart Bull",
    subtitle: "Mais de 04 de experiência operando no mercado financeiro",
    data: [
      {
        value: "+700",
        description: "Pontos por ano",
      },
      {
        value: "+30",
        description: "Clientes Satisfeitos",
      },
      {
        value: "1,6k",
        description: "Ordens Executadas por ano",
      },
    ],
  },

  features: {
    title: "Por que utilizar os robôs Golden Bull",
    subtitle: "Veja quais as principais vantagens dos nossos robôs.",
    data: [
      {
        icon: iconsSet.calendar,
        title: "7 dias para testar",
        description:
          "Teste nossa estratégia e confira a performance em sua conta",
      },
      {
        icon: iconsSet.code,
        title: "100% automatizado",
        description:
          "Realizamos todos ajustes e parametrizações da estratégia automaticamente.",
      },
      {
        icon: iconsSet.chat,
        title: "Suporte Individual",
        description:
          "Priorizamos um atendimento individual de qualidade visando sempre esclarecer as dúvidas de nossos clientes.",
      },
      {
        icon: iconsSet.lightning,
        title: "Velocidade",
        description:
          "Os nossos algoritmos conseguem realizar cálculos após a abertura, tomando decisões mais rápido que qualquer ser humano.",
      },
      {
        icon: iconsSet.clock,
        title: "Ganhe Tempo",
        description:
          "Você não precisa ficar na frente do computador para realizar suas operações. Após sua escolha, a automação opera por você.",
      },
      {
        icon: iconsSet.favorite,
        title: "Sem Emocional",
        description:
          "Com a estratégia automatizada você vai acabar com todos seus problemas de tomar decisões impulsivas e irracionais",
      },
      // ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "Iniciei com a operação a cerca de 1 mês e estou gostando muito do produto! Comecei com 1,5K de margem e até o momento o saldo foi positivo mesmo com tantas adversidades, como a guerra em Israel. Além do robô ser incrível, o atendimento e disponibilidade dos funcionários da Smart Bull é excelente! Recomendo demais.",
      author: "João Pedro",
      job: "Estudante",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
    },
    {
      text: "O que mais gostei no Smart Bull foi a respeito do gerenciamento de risco, buscando sempre em cada trade um risco x retorno positivo. Acho isso crucial em uma estratégia para durar no médio e longo prazo.",
      author: "Israel Martins",
      job: "Gerente de Faturamento",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Conheça os nossos planos",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
